import type { ColorTheme } from './types';

export const colorThemes = ['purple-yellow', 'green-pink', 'bordeaux-gray', 'blue-orange', 'red-lightblue'] satisfies ColorTheme[];
